var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout-footer',[_c('p',{staticClass:"copyright"},[_vm._v("\n    Copyright © 2022 (Sipulpen) BKPSDM KABUPATEN KARAWANG\n    "),_c('a',{attrs:{"href":"https://creative-tim.com"}},[_vm._v("Creative Tim")]),_vm._v(".\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }